"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BPMNEntity = void 0;
var BPMNEntity = (function () {
    function BPMNEntity(nodeName, value, attributes, children) {
        this._nodeName = nodeName;
        this._value = value;
        this._children = children;
        this._attributes = attributes;
    }
    Object.defineProperty(BPMNEntity.prototype, "nodeName", {
        get: function () { return this._nodeName; },
        set: function (aName) { this._nodeName = aName; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BPMNEntity.prototype, "children", {
        get: function () { return this._children; },
        set: function (Children) { this._children = Children; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BPMNEntity.prototype, "attributes", {
        get: function () { return this._attributes; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BPMNEntity.prototype, "value", {
        get: function () { return this._value; },
        set: function (val) { this._value = val; },
        enumerable: false,
        configurable: true
    });
    BPMNEntity.prototype.ToObject = function () {
        var obj = {};
        if (this._attributes !== undefined)
            for (var attr in this._attributes) {
                obj['@' + attr] = this._attributes[attr];
            }
        if (this._children !== undefined) {
            for (var child in this._children) {
                obj[child] = new Array();
                for (var c in this._children[child]) {
                    obj[child].push(this._children[child][c].ToObject());
                }
            }
        }
        if (this._value !== undefined) {
            obj['#'] = this._value;
        }
        return obj;
    };
    BPMNEntity.prototype.setAttribute = function (key, val) { if (this._attributes === undefined)
        this._attributes = {}; this._attributes[key] = val; };
    BPMNEntity.prototype.addChild = function (child) {
        if (this._children === undefined)
            this._children = {};
        if (this._children[child.nodeName] === undefined) {
            this._children[child.nodeName] = new Array();
        }
        this._children[child.nodeName].push(child);
    };
    return BPMNEntity;
}());
exports.BPMNEntity = BPMNEntity;
//# sourceMappingURL=BPMNEntity.js.map